module.exports = __webpack_public_path__ + "static/media/no-sensor-box.7564e76a.svg";